// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","Photos__row":"ti_a bie_a bie_r bie_j","Photos__img":"ti_b bie_b"};